import { Injectable } from "@angular/core";
import { Equipamento } from '@tivic-team/manager-ts/dist/grl';
import { ConcessaoVeiculoDTO } from "app/model/dtos/mob/concessao-veiculo.dto";
import { HttpGet, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environmentv3 } from "src/environments/environmentv3";
import { ApiController } from '../api-controller.interface';

@Injectable()
export class EquipamentoController implements ApiController<Equipamento>{
    find(filters?: IFilter): Promise<Equipamento[]> {
        throw new Error('Method not implemented.');
    }
    get(id: number): Promise<Equipamento> {
        throw new Error('Method not implemented.');
    }
    create(entity: Equipamento): Promise<Equipamento> {
        throw new Error('Method not implemented.');
    }
    update(entity: Equipamento): Promise<Equipamento> {
        throw new Error('Method not implemented.');
    }

    getEquipamentoByConcessao(filters ? : IFilter): Promise<Equipamento> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/equipamentos/concessao',
                    environment: environmentv3,
                    filter: filters
                }),
            }),
            new HttpResponse(new Equipamento())
        );

        return request.call();
    }

    public getEquipamentoByConcessaoVeiculo(cdConcessaoVeiculo: number): Promise<Equipamento> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/equipamentos/:cdConcessaoVeiculo/equipamento',
                    environment: environmentv3,
                    pathParams: new JSONData({ cdConcessaoVeiculo: cdConcessaoVeiculo })
                }),
            }),
            new HttpResponse(new Equipamento())
        );
        return request.call();
    }

    inativar(concessaoVeiculoDTO: ConcessaoVeiculoDTO): Promise<Equipamento> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'grl/equipamentos/inativar/:cdVeiculo',
                    environment: environmentv3,
                    pathParams: new JSONData({ cdVeiculo: concessaoVeiculoDTO.cdVeiculo})
                }),
                data: new JSONData(concessaoVeiculoDTO)
            }),
            new HttpResponse(new Equipamento())
        );

        return request.call();
    }
}